export function isDefenseReport(report) {
  return report?.kind === "defense_report";
}

export function defenseHeld(report) {
  return report?.outcomes?.winner === "defender";
}

export function battleReportIdFromIntel(report) {
  const n = Math.floor(Number(report?.outcomes?.battleReportId));
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function intelReportTitle(report) {
  if (isDefenseReport(report)) {
    const nick = report.other_nickname || "Unknown";
    return `Defense: ${nick} — ${defenseHeld(report) ? "Victory" : "Defeat"}`;
  }
  if (report?.kind === "counter_intel") {
    return `Counter-Intel — ${report.other_nickname || "Unknown"}`;
  }
  return `Scout Report — ${report?.city_name || report?.other_nickname || "Unknown"}`;
}

function casualtyLostTotal(bucket) {
  if (!bucket || typeof bucket !== "object") return 0;
  let total = 0;
  for (const value of Object.values(bucket)) {
    if (value && typeof value === "object") {
      total += Math.max(0, Math.floor(Number(value.lost) || 0));
    } else {
      total += Math.max(0, Math.floor(Number(value) || 0));
    }
  }
  return total;
}

export function intelReportMeta(report) {
  if (isDefenseReport(report)) {
    const salvage = report.outcomes?.salvage || {};
    const parts = ["iron", "food", "wood", "essence"]
      .map((key) => {
        const n = Math.max(0, Math.floor(Number(salvage[key]) || 0));
        if (n < 1) return null;
        const label = key.charAt(0).toUpperCase() + key.slice(1);
        return `+${n} ${label}`;
      })
      .filter(Boolean);
    const lost = casualtyLostTotal(report.outcomes?.casualties?.defender);
    const lossBit = lost > 0 ? `${lost} lost` : "No losses";
    if (parts.length) return `${lossBit} · ${parts.join(", ")}`;
    return lossBit;
  }
  const o = report?.outcomes || {};
  if (report?.kind === "counter_intel") {
    const n = Math.max(0, Math.floor(Number(o.captured) || 0));
    return n === 1 ? "1 captured" : `${n} captured`;
  }
  const success = Math.max(0, Math.floor(Number(o.success) || 0));
  return `${success} returned`;
}

export function intelReportTone(report) {
  if (isDefenseReport(report)) {
    return defenseHeld(report) ? "held" : "fallen";
  }
  return report?.read_at ? "" : "new";
}
